import React from "react";
import { HomeCardButton, HomeCard, HomeCardText, IconContainer } from "./style";
import { HomePageCard } from "@customTypes/pages/home";
import { HomeCardHeading } from "./style";
import { useHistory } from "react-router-dom";

export const Card: React.FC<HomePageCard> = ({ title, subtitle, icon, link }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(link);
  };

  return (
    <HomeCard border>
      <IconContainer>
        {icon()}
        <HomeCardHeading size="sm" color="gray">
          {title}
        </HomeCardHeading>
      </IconContainer>
      <HomeCardText size="lg" color="gray">
        {subtitle}
      </HomeCardText>
      <HomeCardButton color="primary" outline onClick={handleClick}>
        Acessar
      </HomeCardButton>
    </HomeCard>
  );
};
